const Columns1 = [
  {
    Header: "Name",
    accessor: "name",
  },

  // {
  //   Header: "Name",
  //   accessor: "name",
  // },
  // {
  //   Header: "Date",
  //   accessor: "date",
  // },

  // {
  //   Header: "BuyIn",
  //   accessor: "buyIn",
  // },
  // {
  //   Header: "Players",
  //   accessor: "players",
  // },
  // {
  //   Header: "Status",
  //   accessor: "status",
  // },

];
const UM = { Columns1 };
export default UM;